import { Component } from '@angular/core';

import type { CardData } from '@shared/components';
import { YoutubePlayerComponent, HoverExpandableCardsComponent } from '@shared/components';

@Component({
  selector: 'app-previs-and-production',
  imports: [HoverExpandableCardsComponent, YoutubePlayerComponent],
  templateUrl: './previs-and-production.html',
  styleUrl: './previs-and-production.scss',
})
export class PrevisAndProduction {
  readonly expandableCards: CardData[] = [
    {
      video: 'assets/previs-and-production/vinod-exterior.webm',
      title: 'Previs for\nfilm and animation',
      description: 'Block out your scene in true 3D and lock the camera before the shoot.',
    },
    {
      video: 'assets/previs-and-production/anima-elder.webm',
      title: 'Production for\nshort-form',
      description: 'Direct the scene with control and consistency before you hand it to the model',
    },
  ];
}
